export function audioManager() {
	let currentAudioSource: MediaElementAudioSourceNode;
	let dataArray: Float32Array<ArrayBuffer> | undefined;
	let analyser: AnalyserNode | undefined;
	let audioContext: AudioContext | undefined;
	let gainNode: GainNode | undefined;

	function startAudio() {
		const connected = createAnalyser();
		dataArray = connected.dataArray;
		analyser = connected.analyser;
		audioContext = connected.audioContext;
		gainNode = connected.gainNode;
	}

	function createAnalyser() {
		const audioContext = new window.AudioContext();
		const analyser = audioContext.createAnalyser();
		analyser.fftSize = 2048;
		const bufferLength = analyser.frequencyBinCount;
		const dataArray = new Float32Array(bufferLength);
		const gainNode = audioContext.createGain();
		// The analyser taps the full-amplitude signal (source → analyser) so the
		// head animation is independent of output volume. Audible level is applied
		// downstream via the gain node (analyser → gain → destination).
		analyser.connect(gainNode);
		gainNode.connect(audioContext.destination);
		return { analyser, dataArray, audioContext, gainNode };
	}

	function getDataArray(): number[] {
		if (analyser && dataArray) {
			analyser.getFloatTimeDomainData(dataArray);
			return [...dataArray];
		} else {
			return [];
		}
	}

	function connectToAnalyser(audioElement: HTMLAudioElement) {
		if (audioContext !== undefined && analyser !== undefined) {
			try {
				const newCurrentAudioSource = audioContext.createMediaElementSource(audioElement);
				currentAudioSource = newCurrentAudioSource;
				currentAudioSource.connect(analyser);
			} catch (e) {
				console.error(e);
			}
		}
	}

	/** Set audible output volume (0.0–1.0) without affecting analyser amplitude. */
	function setVolume(volume: number) {
		if (gainNode) {
			gainNode.gain.value = Math.min(1, Math.max(0, volume));
		}
	}

	return {
		connectToAnalyser,
		getDataArray,
		startAudio,
		setVolume
	};
}

export type AudioPartialData = {
	media_url: string;
	mute: boolean;
	noCrossOrigin?: boolean;
};

export function createAudioElement(data: AudioPartialData) {
	const audio = document.createElement('audio');
	if (!data.noCrossOrigin) {
		audio.crossOrigin = 'anonymous';
	}
	audio.src = data.media_url;
	audio.muted = data.mute;
	return audio;
}
